export default __webpack_public_path__ + "static/media/downArrowRed.ff8035db.svg";